export var FETCH_ACCOUNT_HISTORY = 'FETCH_ACCOUNT_HISTORY';
export var SUCCESS_FETCH_ACCOUNT_HISTORY = 'SUCCESS_FETCH_ACCOUNT_HISTORY';
export var FAILURE_FETCH_ACCOUNT_HISTORY = 'FAILURE_FETCH_ACCOUNT_HISTORY';
export var CLEAR_ACCOUNT_HISTORY = 'CLEAR_ACCOUNT_HISTORY';



// WEBPACK FOOTER //
// ./src/actions/accountHistory.js